// @flow

import { rem } from 'polished';
import styled from 'styled-components';

export default styled.footer`
  min-width: ${rem(1115)};
`;
